import React, {useEffect, useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../authConfig";
import Spinner from "./Spinner";

export function Home() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //function will run after the component has rendered
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    let greeting = "Hi!";
    if (account) {
        greeting = "Hi " + account.idTokenClaims["given_name"] + "!";
    }

    return (
        <div>
            {loading ? (<Spinner/>) : (
                <div>
                    <h1 className="page-title"> Welcome to the CubeWraps Nucleus!</h1>
                    <hr/>
                    <br/>
                    <div className="list-section">
                        <AuthenticatedTemplate>
                            <h4 className="text-secondary">{greeting}</h4>
                            <br/>
                            <p>This site is a work in progress. More functionality will be added soon.</p>
                            <p>This is currently a demo of the admin layout of the site </p>
                        </AuthenticatedTemplate>

                        <UnauthenticatedTemplate>
                            <h5>Please log in with your CubeWraps (admin) account to continue.</h5>
                            <br/>
                            <button className="btn btn-secondary align-items-center" onClick={loginRedirect}>Sign in
                            </button>

                        </UnauthenticatedTemplate>
                    </div>

                    <div className="page-break"></div>
                </div>
            )}
        </div>
    );
}
